export default class RomaneioSelect {
  constructor(id = "", nome = "", idFuncionario = "", idPraca = "", funcionario = "") {
    this.Id = id
    this.Nome = nome
    this.IdFuncionario = idFuncionario
    this.IdPraca = idPraca
    this.Funcionario = funcionario
  }
}
